/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RichtextFacet from '../../../app/bsky/richtext/facet.defs.js'
import * as EmbedRecord from '../../../app/bsky/embed/record.defs.js'
import * as ActorDefs from '../actor/defs.defs.js'

const $nsid = 'chat.bsky.convo.defs'

export { $nsid }

type MessageRef = {
  $type?: 'chat.bsky.convo.defs#messageRef'
  did: l.DidString
  convoId: string
  messageId: string
}

export type { MessageRef }

const messageRef = l.typedObject<MessageRef>(
  $nsid,
  'messageRef',
  l.object({
    did: l.string({ format: 'did' }),
    convoId: l.string(),
    messageId: l.string(),
  }),
)

export { messageRef }

type MessageInput = {
  $type?: 'chat.bsky.convo.defs#messageInput'
  text: string

  /**
   * Annotations of text (mentions, URLs, hashtags, etc)
   */
  facets?: RichtextFacet.Main[]
  embed?: l.$Typed<EmbedRecord.Main> | l.Unknown$TypedObject
}

export type { MessageInput }

const messageInput = l.typedObject<MessageInput>(
  $nsid,
  'messageInput',
  l.object({
    text: l.string({ maxLength: 10000, maxGraphemes: 1000 }),
    facets: l.optional(
      l.array(l.ref<RichtextFacet.Main>((() => RichtextFacet.main) as any)),
    ),
    embed: l.optional(
      l.typedUnion(
        [l.typedRef<EmbedRecord.Main>((() => EmbedRecord.main) as any)],
        false,
      ),
    ),
  }),
)

export { messageInput }

type MessageView = {
  $type?: 'chat.bsky.convo.defs#messageView'
  id: string
  rev: string
  text: string

  /**
   * Annotations of text (mentions, URLs, hashtags, etc)
   */
  facets?: RichtextFacet.Main[]
  embed?: l.$Typed<EmbedRecord.View> | l.Unknown$TypedObject

  /**
   * Reactions to this message, in ascending order of creation time.
   */
  reactions?: ReactionView[]
  sender: MessageViewSender
  sentAt: l.DatetimeString
}

export type { MessageView }

const messageView = l.typedObject<MessageView>(
  $nsid,
  'messageView',
  l.object({
    id: l.string(),
    rev: l.string(),
    text: l.string({ maxLength: 10000, maxGraphemes: 1000 }),
    facets: l.optional(
      l.array(l.ref<RichtextFacet.Main>((() => RichtextFacet.main) as any)),
    ),
    embed: l.optional(
      l.typedUnion(
        [l.typedRef<EmbedRecord.View>((() => EmbedRecord.view) as any)],
        false,
      ),
    ),
    reactions: l.optional(
      l.array(l.ref<ReactionView>((() => reactionView) as any)),
    ),
    sender: l.ref<MessageViewSender>((() => messageViewSender) as any),
    sentAt: l.string({ format: 'datetime' }),
  }),
)

export { messageView }

type DeletedMessageView = {
  $type?: 'chat.bsky.convo.defs#deletedMessageView'
  id: string
  rev: string
  sender: MessageViewSender
  sentAt: l.DatetimeString
}

export type { DeletedMessageView }

const deletedMessageView = l.typedObject<DeletedMessageView>(
  $nsid,
  'deletedMessageView',
  l.object({
    id: l.string(),
    rev: l.string(),
    sender: l.ref<MessageViewSender>((() => messageViewSender) as any),
    sentAt: l.string({ format: 'datetime' }),
  }),
)

export { deletedMessageView }

type MessageViewSender = {
  $type?: 'chat.bsky.convo.defs#messageViewSender'
  did: l.DidString
}

export type { MessageViewSender }

const messageViewSender = l.typedObject<MessageViewSender>(
  $nsid,
  'messageViewSender',
  l.object({ did: l.string({ format: 'did' }) }),
)

export { messageViewSender }

type ReactionView = {
  $type?: 'chat.bsky.convo.defs#reactionView'
  value: string
  sender: ReactionViewSender
  createdAt: l.DatetimeString
}

export type { ReactionView }

const reactionView = l.typedObject<ReactionView>(
  $nsid,
  'reactionView',
  l.object({
    value: l.string(),
    sender: l.ref<ReactionViewSender>((() => reactionViewSender) as any),
    createdAt: l.string({ format: 'datetime' }),
  }),
)

export { reactionView }

type ReactionViewSender = {
  $type?: 'chat.bsky.convo.defs#reactionViewSender'
  did: l.DidString
}

export type { ReactionViewSender }

const reactionViewSender = l.typedObject<ReactionViewSender>(
  $nsid,
  'reactionViewSender',
  l.object({ did: l.string({ format: 'did' }) }),
)

export { reactionViewSender }

type MessageAndReactionView = {
  $type?: 'chat.bsky.convo.defs#messageAndReactionView'
  message: MessageView
  reaction: ReactionView
}

export type { MessageAndReactionView }

const messageAndReactionView = l.typedObject<MessageAndReactionView>(
  $nsid,
  'messageAndReactionView',
  l.object({
    message: l.ref<MessageView>((() => messageView) as any),
    reaction: l.ref<ReactionView>((() => reactionView) as any),
  }),
)

export { messageAndReactionView }

type ConvoView = {
  $type?: 'chat.bsky.convo.defs#convoView'
  id: string
  rev: string
  members: ActorDefs.ProfileViewBasic[]
  lastMessage?:
    | l.$Typed<MessageView>
    | l.$Typed<DeletedMessageView>
    | l.Unknown$TypedObject
  lastReaction?: l.$Typed<MessageAndReactionView> | l.Unknown$TypedObject
  muted: boolean
  status?: 'request' | 'accepted' | l.UnknownString
  unreadCount: number
}

export type { ConvoView }

const convoView = l.typedObject<ConvoView>(
  $nsid,
  'convoView',
  l.object({
    id: l.string(),
    rev: l.string(),
    members: l.array(
      l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
    ),
    lastMessage: l.optional(
      l.typedUnion(
        [
          l.typedRef<MessageView>((() => messageView) as any),
          l.typedRef<DeletedMessageView>((() => deletedMessageView) as any),
        ],
        false,
      ),
    ),
    lastReaction: l.optional(
      l.typedUnion(
        [
          l.typedRef<MessageAndReactionView>(
            (() => messageAndReactionView) as any,
          ),
        ],
        false,
      ),
    ),
    muted: l.boolean(),
    status: l.optional(l.string<{ knownValues: ['request', 'accepted'] }>()),
    unreadCount: l.integer(),
  }),
)

export { convoView }

type LogBeginConvo = {
  $type?: 'chat.bsky.convo.defs#logBeginConvo'
  rev: string
  convoId: string
}

export type { LogBeginConvo }

const logBeginConvo = l.typedObject<LogBeginConvo>(
  $nsid,
  'logBeginConvo',
  l.object({ rev: l.string(), convoId: l.string() }),
)

export { logBeginConvo }

type LogAcceptConvo = {
  $type?: 'chat.bsky.convo.defs#logAcceptConvo'
  rev: string
  convoId: string
}

export type { LogAcceptConvo }

const logAcceptConvo = l.typedObject<LogAcceptConvo>(
  $nsid,
  'logAcceptConvo',
  l.object({ rev: l.string(), convoId: l.string() }),
)

export { logAcceptConvo }

type LogLeaveConvo = {
  $type?: 'chat.bsky.convo.defs#logLeaveConvo'
  rev: string
  convoId: string
}

export type { LogLeaveConvo }

const logLeaveConvo = l.typedObject<LogLeaveConvo>(
  $nsid,
  'logLeaveConvo',
  l.object({ rev: l.string(), convoId: l.string() }),
)

export { logLeaveConvo }

type LogMuteConvo = {
  $type?: 'chat.bsky.convo.defs#logMuteConvo'
  rev: string
  convoId: string
}

export type { LogMuteConvo }

const logMuteConvo = l.typedObject<LogMuteConvo>(
  $nsid,
  'logMuteConvo',
  l.object({ rev: l.string(), convoId: l.string() }),
)

export { logMuteConvo }

type LogUnmuteConvo = {
  $type?: 'chat.bsky.convo.defs#logUnmuteConvo'
  rev: string
  convoId: string
}

export type { LogUnmuteConvo }

const logUnmuteConvo = l.typedObject<LogUnmuteConvo>(
  $nsid,
  'logUnmuteConvo',
  l.object({ rev: l.string(), convoId: l.string() }),
)

export { logUnmuteConvo }

type LogCreateMessage = {
  $type?: 'chat.bsky.convo.defs#logCreateMessage'
  rev: string
  convoId: string
  message:
    | l.$Typed<MessageView>
    | l.$Typed<DeletedMessageView>
    | l.Unknown$TypedObject
}

export type { LogCreateMessage }

const logCreateMessage = l.typedObject<LogCreateMessage>(
  $nsid,
  'logCreateMessage',
  l.object({
    rev: l.string(),
    convoId: l.string(),
    message: l.typedUnion(
      [
        l.typedRef<MessageView>((() => messageView) as any),
        l.typedRef<DeletedMessageView>((() => deletedMessageView) as any),
      ],
      false,
    ),
  }),
)

export { logCreateMessage }

type LogDeleteMessage = {
  $type?: 'chat.bsky.convo.defs#logDeleteMessage'
  rev: string
  convoId: string
  message:
    | l.$Typed<MessageView>
    | l.$Typed<DeletedMessageView>
    | l.Unknown$TypedObject
}

export type { LogDeleteMessage }

const logDeleteMessage = l.typedObject<LogDeleteMessage>(
  $nsid,
  'logDeleteMessage',
  l.object({
    rev: l.string(),
    convoId: l.string(),
    message: l.typedUnion(
      [
        l.typedRef<MessageView>((() => messageView) as any),
        l.typedRef<DeletedMessageView>((() => deletedMessageView) as any),
      ],
      false,
    ),
  }),
)

export { logDeleteMessage }

type LogReadMessage = {
  $type?: 'chat.bsky.convo.defs#logReadMessage'
  rev: string
  convoId: string
  message:
    | l.$Typed<MessageView>
    | l.$Typed<DeletedMessageView>
    | l.Unknown$TypedObject
}

export type { LogReadMessage }

const logReadMessage = l.typedObject<LogReadMessage>(
  $nsid,
  'logReadMessage',
  l.object({
    rev: l.string(),
    convoId: l.string(),
    message: l.typedUnion(
      [
        l.typedRef<MessageView>((() => messageView) as any),
        l.typedRef<DeletedMessageView>((() => deletedMessageView) as any),
      ],
      false,
    ),
  }),
)

export { logReadMessage }

type LogAddReaction = {
  $type?: 'chat.bsky.convo.defs#logAddReaction'
  rev: string
  convoId: string
  message:
    | l.$Typed<MessageView>
    | l.$Typed<DeletedMessageView>
    | l.Unknown$TypedObject
  reaction: ReactionView
}

export type { LogAddReaction }

const logAddReaction = l.typedObject<LogAddReaction>(
  $nsid,
  'logAddReaction',
  l.object({
    rev: l.string(),
    convoId: l.string(),
    message: l.typedUnion(
      [
        l.typedRef<MessageView>((() => messageView) as any),
        l.typedRef<DeletedMessageView>((() => deletedMessageView) as any),
      ],
      false,
    ),
    reaction: l.ref<ReactionView>((() => reactionView) as any),
  }),
)

export { logAddReaction }

type LogRemoveReaction = {
  $type?: 'chat.bsky.convo.defs#logRemoveReaction'
  rev: string
  convoId: string
  message:
    | l.$Typed<MessageView>
    | l.$Typed<DeletedMessageView>
    | l.Unknown$TypedObject
  reaction: ReactionView
}

export type { LogRemoveReaction }

const logRemoveReaction = l.typedObject<LogRemoveReaction>(
  $nsid,
  'logRemoveReaction',
  l.object({
    rev: l.string(),
    convoId: l.string(),
    message: l.typedUnion(
      [
        l.typedRef<MessageView>((() => messageView) as any),
        l.typedRef<DeletedMessageView>((() => deletedMessageView) as any),
      ],
      false,
    ),
    reaction: l.ref<ReactionView>((() => reactionView) as any),
  }),
)

export { logRemoveReaction }
